export default __webpack_public_path__ + "static/media/turn-ideas-into-reality-2048w.5eb53c5f.avif";